export const silverData = [
  {
    id: 1,
    name: "Luna Heart Pendant",
    type:"pendant",
    image:  "/silver/img1.jpeg",
    price: 2499,
    discountedPrice: 1999,
    discountPercent: 20,
    weight: "4.2g",
    size: "20mm x 18mm",
    material:"Silver + Opal",
    length: "18 inch chain",
    manufacturing: "Handcrafted in Jaipur",
    returnPolicy: "7 days return",
    secSilverPercent: "92.5%",
    warranty: "6 months",
    shipping: "Free"
  },
  {
    id: 2,
    name: "Elegant Floral Studs",
    image:  "/silver/img2.jpeg",
    price: 1899,
    discountedPrice: 1499,
    discountPercent: 21,
    weight: "3.1g",
    size: "12mm",
    material:  "Silver + CZ",
    length: "N/A",
    manufacturing: "Polished finish",
    returnPolicy: "7 days return",
    secSilverPercent: "92.5%",
    warranty: "1 year",
    shipping: "Free"
  },
  {
    id: 3,
    name: "Crystal Drop Earrings",
    image:  "/silver/img3.jpeg",
    price: 2999,
    discountedPrice: 2199,
    discountPercent: 26,
    weight: "5.6g",
    size: "40mm",
    material: "Silver + Opal",
    length: "Drop design",
    manufacturing: "Stone embedded",
    returnPolicy: "7 days exchange",
    secSilverPercent: "92.5%",
    warranty: "1 year",
    shipping: "Free"
  },
  {
    id: 4,
    name: "Classic Silver Ring",
    image:  "/silver/img4.jpeg",
    price: 1599,
    discountedPrice: 1199,
    discountPercent: 25,
    weight: "2.4g",
    size: "Adjustable",
    material: "Silver + Opal",
    length: "N/A",
    manufacturing: "Machine carved",
    returnPolicy: "5 days return",
    secSilverPercent: "92.5%",
    warranty: "6 months",
    shipping: "Free"
  },
  {
    id: 5,
    name: "Moonlit Anklet",
    image: "/silver/img5.jpeg",
    price: 2199,
    discountedPrice: 1699,
    discountPercent: 22,
    weight: "7.9g",
    size: "9 inch",
    material: "Sterling Silver 92.5%",
    length: "Adjustable fit",
    manufacturing: "Handmade links",
    returnPolicy: "7 days return",
    secSilverPercent: "92.5%",
    warranty: "1 year",
    shipping: "Free"
  },
  {
    id: 6,
    name: "Lotus Silver Bracelet",
    image:  "/silver/img6.jpeg",
    price: 2899,
    discountedPrice: 2299,
    discountPercent: 21,
    weight: "6.3g",
    size: "Free size",
    material: "Silver + Opal",
    length: "7 inch",
    manufacturing: "Premium detailing",
    returnPolicy: "7 days return",
    secSilverPercent: "92.5%",
    warranty: "1 year",
    shipping: "Free"
  },
  {
    id: 7,
    name: "Solitaire Silver Ring",
    image: "/silver/img7.jpeg",
    price: 3299,
    discountedPrice: 2499,
    discountPercent: 24,
    weight: "3.0g",
    size: "Available in 4 sizes",
    material: "Sterling Silver 92.5%",
    length: "N/A",
    manufacturing: "Crystal stone setting",
    returnPolicy: "10 days return",
    secSilverPercent: "92.5%",
    warranty: "1 year",
    shipping: "Free"
  },
  {
    id: 8,
    name: "Infinity Pendant Chain",
    image: "/silver/img8.jpeg",
    price: 2499,
    discountedPrice: 1799,
    discountPercent: 28,
    weight: "4.7g",
    size: "Pendant: 22mm",
    material: "Sterling Silver 92.5%",
    length: "20 inch",
    manufacturing: "Laser engraved",
    returnPolicy: "7 days replacement",
    secSilverPercent: "92.5%",
    warranty: "1 year",
    shipping: "Free"
  },
  {
    id: 9,
    name: "Vintage Pearl Earrings",
    image:"/silver/img9.jpeg",
    price: 2799,
    discountedPrice: 2099,
    discountPercent: 25,
    weight: "5.2g",
    size: "30mm",
    material: "Silver + Opal",
    length: "Drop style",
    manufacturing: "Pearl embedded",
    returnPolicy: "7 days return",
    secSilverPercent: "92.5%",
    warranty: "1 year",
    shipping: "Free"
  },
  {
    id: 10,
    name: "Royal Silver Kada",
    image: "/silver/img10.jpeg",
    price: 3999,
    discountedPrice: 2999,
    discountPercent: 25,
    weight: "18g",
    size: "Free size",
    material:  "Silver + CZ",
    length: "Adjustable",
    manufacturing: "Traditional design",
    returnPolicy: "7 day return",
    secSilverPercent: "92.5%",
    warranty: "1 year",
    shipping: "Free"
  },

  // --- Remaining 14 items ---
  {
    id: 11,
    name: "Feather Drop Earrings",
    image:"/silver/img11.jpeg",
    price: 2599,
    discountedPrice: 1899,
    discountPercent: 27,
    weight: "4.8g",
    size: "35mm",
    material:  "Silver + CZ",
    length: "Lightweight",
    manufacturing: "Oxidised finish",
    returnPolicy: "7 days",
    secSilverPercent: "92.5%",
    warranty: "6 months",
    shipping: "Free"
  },
  {
    id: 12,
    name: "Twisted Rope Ring",
    image: "/silver/img12.jpeg",
    price: 1799,
    discountedPrice: 1399,
    discountPercent: 22,
    weight: "2.1g",
    size: "Adjustable",
    material: "Sterling Silver 92.5%",
    manufacturing: "Handcrafted",
    returnPolicy: "7 days",
    secSilverPercent: "92.5%",
    warranty: "1 year",
    shipping: "Free"
  },
  {
    id: 13,
    name: "Silver Pearl Pendant",
    image:"/silver/img13.jpeg",
    price: 2899,
    discountedPrice: 2299,
    discountPercent: 21,
    weight: "3.9g",
    size: "20mm pendant",
    material:  "Silver + CZ",
    length: "18 inch chain",
    manufacturing: "Pearl setting",
    returnPolicy: "7 days",
    secSilverPercent: "92.5%",
    warranty: "1 year",
    shipping: "Free"
  },
  {
    id: 14,
    name: "Oxidised Tribal Necklace",
    image: "/silver/img14.jpeg",
    price: 4999,
    discountedPrice: 3799,
    discountPercent: 24,
    weight: "22g",
    size: "Full necklace",
    material: "Sterling Silver 92.5%",
    length: "16 inch",
    manufacturing: "Traditional Rajasthani craft",
    returnPolicy: "10 days",
    secSilverPercent: "92.5%",
    warranty: "1 year",
    shipping: "Free"
  },
  {
    id: 15,
    name: "Charm Bracelet",
    image:"/silver/img15.jpeg",
    price: 2999,
    discountedPrice: 2199,
    discountPercent: 26,
    weight: "8.2g",
    size: "Free size",
    material: "Sterling Silver 92.5%",
    manufacturing: "Multi-charm design",
    returnPolicy: "7 days",
    secSilverPercent: "92.5%",
    warranty: "1 year",
    shipping: "Free"
  },
  {
    id: 16,
    name: "Elegant Toe Rings",
    image: "/silver/img16.jpeg",
    price: 1399,
    discountedPrice: 999,
    discountPercent: 28,
    weight: "1.2g",
    size: "Adjustable",
    material:  "Silver + CZ",
    manufacturing: "Pack of 2",
    returnPolicy: "5 days",
    secSilverPercent: "92.5%",
    warranty: "6 months",
    shipping: "Free"
  },
  {
    id: 17,
    name: "Moonbeam Silver Chain",
    image: "/silver/img17.jpeg",
    price: 2499,
    discountedPrice: 1899,
    discountPercent: 24,
    weight: "6.5g",
    size: "20 inch",
    material: "Sterling Silver 92.5%",
    manufacturing: "Classic link chain",
    returnPolicy: "7 days",
    secSilverPercent: "92.5%",
    warranty: "1 year",
    shipping: "Free"
  },
  {
    id: 18,
    name: "Petal Stud Earrings",
    image: "/silver/img18.jpeg",
    price: 1699,
    discountedPrice: 1299,
    discountPercent: 23,
    weight: "2.4g",
    size: "11mm",
    material:  "Silver + CZ",
    manufacturing: "Petal design",
    returnPolicy: "7 days",
    secSilverPercent: "92.5%",
    warranty: "1 year",
    shipping: "Free"
  },
  {
    id: 19,
    name: "Crystal Charm Anklet",
    image: "/silver/img19.jpeg",
    price: 2299,
    discountedPrice: 1699,
    discountPercent: 26,
    weight: "7g",
    size: "9.5 inch",
    material: "Sterling Silver 92.5%",
    manufacturing: "Crystal charms",
    returnPolicy: "7 days",
    secSilverPercent: "92.5%",
    warranty: "1 year",
    shipping: "Free"
  },
  {
    id: 20,
    name: "Diamond Cut Chain",
    image: "/silver/img20.jpeg",
    price: 2999,
    discountedPrice: 2399,
    discountPercent: 20,
    weight: "7.1g",
    size: "18 inch",
    material:  "Silver + CZ",
    manufacturing: "Machine carved",
    returnPolicy: "7 days return",
    secSilverPercent: "92.5%",
    warranty: "1 year",
    shipping: "Free"
  },
  {
    id: 21,
    name: "Silver Round Studs",
    image: "/silver/img21.jpeg",
    price: 1299,
    discountedPrice: 999,
    discountPercent: 23,
    weight: "1.9g",
    size: "10mm",
    material: "Sterling Silver 92.5%",
    manufacturing: "Polished",
    returnPolicy: "5 days return",
    secSilverPercent: "92.5%",
    warranty: "6 months",
    shipping: "Free"
  },
  {
    id: 22,
    name: "Moonstone Pendant",
    image: "/silver/img22.jpeg",
    price: 3299,
    discountedPrice: 2599,
    discountPercent: 21,
    weight: "4.5g",
    size: "25mm",
    material: "Sterling Silver 92.5%",
    length: "18 inch",
    manufacturing: "Stone inlay",
    returnPolicy: "7 days exchange",
    secSilverPercent: "92.5%",
    warranty: "1 year",
    shipping: "Free"
  },
  {
    id: 23,
    name: "Royal Hathphool",
    image: "/silver/img23.jpeg",
    price: 4499,
    discountedPrice: 3499,
    discountPercent: 22,
    weight: "14g",
    size: "Hand accessory",
    material: "Sterling Silver 92.5%",
    manufacturing: "Rajasthani handcrafted",
    returnPolicy: "10 days",
    secSilverPercent: "92.5%",
    warranty: "1 year",
    shipping: "Free"
  },
  {
    id: 24,
    name: "Butterfly Pendant Chain",
    image: "/silver/img24.jpeg",
    price: 2599,
    discountedPrice: 1999,
    discountPercent: 23,
    weight: "4.1g",
    size: "22mm pendant",
    material: "Sterling Silver 92.5%",
    length: "18 inch chain",
    manufacturing: "Butterfly design",
    returnPolicy: "7 days return",
    secSilverPercent: "92.5%",
    warranty: "1 year",
    shipping: "Free"
  }
];
